import { APIError } from './APIError';

export class APINetworkError extends APIError {
  constructor(...args: ConstructorParameters<typeof APIError>) {
    super(...args);

    // Set name explicitly as minification can mangle class names
    Object.defineProperty(this, 'name', { value: 'APINetworkError' });
  }
}
